import { dayjs } from './datetime';

/** "2 minutes ago" / "in 3 days" for an ISO date; '' for empty or invalid input. */
export const relativeTime = (iso: string, now = Date.now()): string => {
  if (!iso || Number.isNaN(Date.parse(iso))) return '';
  return dayjs(iso).from(dayjs(now));
};
